"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _query = require("@reduxjs/toolkit/query");

require("typeface-roboto");

var _material = require("@mui/material");

var _services = require("@alycecom/services");

var _EmailPreviewWarningBar = _interopRequireDefault(require("../../../../../Shared/components/EmailPreviewWarningBar"));

var _EmailPreview = _interopRequireDefault(require("../../../../../Shared/components/EmailPreview"));

var styles = {
  root: {
    margin: '30px auto 111px auto',
    width: 890,
    minHeight: 500
  },
  loaderWrapper: {
    pt: 25,
    mx: 'auto',
    textAlign: 'center'
  },
  loader: {
    margin: '0 auto'
  }
};

var BatchEmailPreview = function BatchEmailPreview(_ref) {
  var batchId = _ref.batchId;

  var _useGetProspectingBat = (0, _services.useGetProspectingBatchEmailPreviewByIdQuery)(batchId ? {
    batchId
  } : _query.skipToken),
      previewData = _useGetProspectingBat.data,
      isPending = _useGetProspectingBat.isFetching,
      isFulfilled = _useGetProspectingBat.isSuccess;

  var senderFullName = ((previewData === null || previewData === void 0 ? void 0 : previewData.sendAs) || (previewData === null || previewData === void 0 ? void 0 : previewData.sender) || {}).fullName;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_EmailPreviewWarningBar.default, null), /*#__PURE__*/_react.default.createElement(_material.Paper, {
    sx: styles.root,
    elevation: 2
  }, isPending && /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.loaderWrapper
  }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
    sx: styles.loader
  })), isFulfilled && (previewData === null || previewData === void 0 ? void 0 : previewData.hasIntegration) && /*#__PURE__*/_react.default.createElement(_EmailPreview.default, {
    subject: (previewData === null || previewData === void 0 ? void 0 : previewData.subject) || '',
    body: (previewData === null || previewData === void 0 ? void 0 : previewData.body) || '',
    senderFullName: senderFullName || ''
  }), isFulfilled && !(previewData !== null && previewData !== void 0 && previewData.hasIntegration) &&
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  _react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: (previewData === null || previewData === void 0 ? void 0 : previewData.body) || ''
    }
  })));
};

var _default = BatchEmailPreview;
exports.default = _default;